var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 170,
    viewBox: "0 0 438 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.055 50.5001C71.055 53.7001 48.7217 58.5001 39.055 60.5001C34.3883 73.6667 26.055 105.7 30.055 128.5C35.055 157 50.555 128.5 70.555 121.5C90.555 114.5 120.055 121.5 141.055 121.5H199.555C225.055 121.5 258.055 128.5 298.055 133.5C338.055 138.5 353.555 135 381.555 128.5C409.555 122 403.555 113.5 408.055 100C411.655 89.2 387.555 88.5 375.055 89.5C366.222 88.6667 348.355 85.8 347.555 81C346.555 75 368.055 66.5 390.555 50.5001C408.555 37.7001 401.388 37.5001 395.555 39L375.055 29C359.888 29.8333 328.355 33 323.555 39C317.555 46.5 308.055 60.5001 298.055 60.5001C288.055 60.5001 265.055 66.5 245.055 66.5H225.055C233.388 61.1667 250.555 50.5001 252.555 50.5001C255.055 50.5001 240.055 42.5 225.055 39C210.055 35.5 201.055 45.5 194.555 50.5001C188.055 55.5001 174.055 77 151.555 75.5C133.555 74.3 137.055 65 141.055 60.5001C126.722 55.8334 95.055 47.3001 83.055 50.5001Z",
    fill: "url(#paint0_linear_19_435)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19_435",
    x: 0,
    y: 0,
    width: 437.418,
    height: 169.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_19_435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_435",
    x1: 218.709,
    y1: 29,
    x2: 218.709,
    y2: 140.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368BAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTop);
export default __webpack_public_path__ + "static/media/right-top.d558f64daa82ec338ca2a0575f9d7150.svg";
export { ForwardRef as ReactComponent };